// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2thyE","label":"Completed_label__2TaBp"};